module.exports = __webpack_public_path__ + "img/free-file.491c41b3.png";